module.exports = __webpack_public_path__ + "img/brand-type1.c211880e.svg";